import React, { useEffect, useState } from "react";
import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Captcha from "./Captcha";
import SuccessIcon from "../Images/Successtoast.png";
import ErrorIcon from "../Images/Errortoast.png";
import { getcoutryfromlocation, useLocation, validateDescription } from "./utility";
import "./EnquirePopup.css";
import { isValidPhoneNumber } from "libphonenumber-js";

const apiUrl = process.env.REACT_APP_BACKEND_URL;

const schema = Yup.object({
  userName: Yup.string().trim().min(3, "Enter valid name").matches(/^[A-Za-z\s]+$/, "Name can only contain letters and spaces").required("Name required"),
  userEmail: Yup.string().email("Invalid email").required("Email required"),
  countryName: Yup.string().required("Select country"),
  phoneNumber: Yup.string().required("Phone number is required").test("valid-phone", "Enter a valid phone number", v => (isValidPhoneNumber(v || ""))),
  description: Yup.string().trim().min(10, "At least 10 chars").max(500, "Max 500 chars").matches(/^[A-Za-z0-9\s.,!?()-]*$/, "Invalid characters"),

});

export default function EnquirePopup({ open, onClose, setOpen }) {
  const [countries, setCountries] = useState([]),
  //  [code, setCode] = useState("in"), 
   [captcha, setCaptcha] = useState('');
  const [toast, setToast] = useState(null);

 useEffect(() => {
    // fetch countries once
    const fetchCountries = async () => {
      try {
        const res = await axios.get(`${apiUrl}api/v1/user/getCountries`);
        setCountries(res?.data?.result || []);
      } catch (err) {
        console.error("Error fetching countries:", err);
      }
    };
    fetchCountries();
  }, []);

  const {countryCode } = useLocation()
  const submit = async (v, { resetForm }) => {
    const cap = JSON.parse(localStorage.getItem("captcha"));
    if (!captcha || !cap) return setToast({ err: true, msg: "Captcha invalid or expired" });

    try {
      const r = await axios.post(`${apiUrl}api/v1/business/createBusinessEnquiry`, {
        enquiry_from: "Influencer",
        name: v.userName,
        email: v.userEmail,
        contact: v.phoneNumber,
        country: v.countryName,
        message: v.description,
        captchaId: cap.id,
        captchaAns: captcha
      });
      setToast({ err: false, msg: r.data?.message || "Submitted!" });
      localStorage.removeItem("captcha"); resetForm();
      setTimeout(() => onClose(), 3000);
    } catch (e) {
      setToast({ err: true, msg: e.response?.data?.message || "Error submitting" });
    } finally {
      setTimeout(() => setToast(null), 3000);
    }
  };
  return (
    <>
      <Dialog open={open} onClose={onClose} className="numberpop">
        <DialogTitle className="text-center">
          Enter Enquiry Details
        </DialogTitle>
        <DialogContent>
          <Formik
            initialValues={{ userName: "", userEmail: "", countryName: "", phoneNumber: "", description: "" }}
            validationSchema={schema}
            onSubmit={submit}
          >
            {({ values, setFieldValue, setFieldTouched, isSubmitting }) => (
              <Form>
                <Field name="userName" placeholder="Name" className="form-control my-2" />
                <ErrorMessage name="userName" component="p" className="text-danger" />
                <Field name="userEmail" type="email" placeholder="Email" className="form-control my-2" />
                <ErrorMessage name="userEmail" component="p" className="text-danger" />
                <Field as="select" name="countryName" className="form-select my-2">
                  <option value="">Select Country</option>
                  {countries.map(c => <option key={c.name} value={c.short_code}>{c.name}</option>)}
                </Field>
                <ErrorMessage name="countryName" component="p" className="text-danger" />
                <PhoneInput
                  countryCodeEditable={false}
                  country={countryCode}
                  value={values.phoneNumber}
                  onChange={(val, c) => setFieldValue("phoneNumber", `+${c.dialCode}-${val.slice(c.dialCode.length)}`)}
                  onBlur={() => setFieldTouched("phoneNumber", true)}
                  inputClass="w-100 my-2"
                />
                <ErrorMessage name="phoneNumber" component="p" className="text-danger" />
                <Field as="textarea" name="description" rows="3" placeholder="Enquiry Details (optional)" className="form-control my-2" />
                <ErrorMessage name="description" component="p" className="text-danger" />
                <Captcha onCaptchaSolved={(val) => setCaptcha(val)} />
                <div className="enquirybtndiv">
                  <button type="submit" disabled={isSubmitting}>
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>

      {toast && (
        <div className="modal1">
          <div className="modal-content1">
            <span className="close closeIconstyle" onClick={() => setToast(null)}>⨉	</span>
            <img className="toastsuccessimg" src={toast.err ? ErrorIcon : SuccessIcon} alt="" />
            <div className="headtostmsg">{toast.err ? "Error!" : "Enquiry Received !!"}</div>
            <p className="responseMessagestyle">{toast.msg}</p>
          </div>
        </div>
      )}
    </>
  );
}
